export function getProgrammeIcon(type) {

    switch (type) {

        case 'talk':
            return '🎤';

        case 'coffee':
            return '☕';

        case 'lunch':
            return '🍽️';

        case 'registration':
            return '📝';

        case 'opening':
            return '🎉';

        case 'trip':
            return '🚌';

        case 'social':
            return '🥂';

        default:
            return '•';

    }

}
